export default "__VITE_ASSET__ac6e86db__"